import NetworkPage from './NetworkPage';
import networkPageReducer from './reducer';

export { networkPageReducer };
export default NetworkPage;
